export default __webpack_public_path__ + "static/media/photoSelfie.b778abd7.jpg";